<div style="
    background-image: url('../../../../assets/imagesNew/Proceed2.png') !important;
    background-size: cover;
    height: 100vh;
  ">
    <span style="color: white; float: right; margin: 4% 7%; position: relative;" *ngIf="(version)"> <h6>V{{version}}</h6> </span>

    <p-dialog [(visible)]="displaypopup"
              [draggable]="false"
              [modal]="true"
              positionType="absolute"
              [closable]="false"
              [maximizable]="false"
              [style]="{ width: '20vw' }">
        <p-header>
            <!--{{popupheader}}-->
            <h2 class="mb-0"
                style="font-weight: unset !important; font-size: larger !important">
                Change Password
            </h2>
        </p-header>

        <div class="grid">
            <div class="col-12 p-md12">
                <form [formGroup]="changePassword" (ngSubmit)="resetPassword()">
                    <div class="p-fluid formgrid grid">
                        <div class="field col-12 md:col-12">
                            <span class="field p-float-label">
                                <input id="float-input1"
                                       type="password"
                                       appFormErrorMessages
                                       pInputText
                                       formControlName="newPassword"
                                       autocomplete="new-password" />

                                <label for="float-input1">
                                    <span class="required-asteric"> * </span>New Password
                                </label>
                            </span>
                        </div>
                        <div class="field col-12 md:col-12">
                            <span class="field p-float-label">
                                <input id="float-input2"
                                       type="password"
                                       appFormErrorMessages
                                       pInputText
                                       formControlName="confirmPassword"
                                       autocomplete="new-password"
                                         

                                       />
                                <label for="float-input1">
                                    <span class="required-asteric"> * </span>Confirm
                                    Password
                                </label>
                            </span>
                        </div>

                        <div class="field col-12 md:col-12 buttonWidth-8 mb-0"
                             style="margin-left: 6rem; text-align: center !important">
                            <button pButton
                                    type="submit"
                                    icon=""
                                    label="Save"
                                    class="p-button-plain"></button>
                        </div>
                    </div>
                </form>

                <div class="col-12 p-messagesp-messages-summary border-radius-5 custom-error"  
                     *ngIf="ShowErrorSummary">
                    <span style="font-size: 14px">{{ errorValidationSummary }}</span>
                </div>
            </div>
        </div>
    </p-dialog>

    <p-dialog [(visible)]="display"
              [style]="{ width: '22vw' }"
              [maximizable]="false"
              [closable]="false"
              [draggable]="false"
              [resizable]="false">
        <ng-template pTemplate="header">
            <div style="text-align: center; width: 100%; font-size: 20px">
                Confirmation!
            </div>
        </ng-template>

        <p style="text-align: center">
            <!--{{logoutmsg}}-->Your password has been changed.<br />You will be
            redirected to the login page.
        </p>
        <ng-template pTemplate="footer">
            <div>
                <p-button icon="pi pi-check"
                          (click)="logout()"
                          label="Ok"
                          styleClass="p-button-text"></p-button>
            </div>
        </ng-template>
    </p-dialog>
</div>
